(() => {
  'use strict';
  const desktop = window.matchMedia('(min-width: 990px)');
  let current = null, pending = false;
  function restore() {
    if (!current) return;
    const { source, links, marker, slot, nav } = current;
    if (marker.parentNode) marker.parentNode.insertBefore(links, marker);
    marker.remove(); slot.remove();
    source.classList.remove('vnk-category-section--integrated');
    nav.classList.remove('vnk-collection-toolbar');
    current = null;
  }
  function releasePending() { document.documentElement?.classList?.remove('vnk-category-pending'); window.clearTimeout?.(window.vnkCategoryFallback); }
  function update() {
    pending = false;
    if (current && (!desktop.matches || !current.nav.isConnected || !current.source.isConnected)) restore();
    if (!desktop.matches || current) { releasePending(); return; }
    const source = document.querySelector('.vnk-category-section');
    const links = source?.querySelector('.subcategory-nav');
    const nav = document.querySelector('[data-collection-nav]');
    if (!links || !nav) { releasePending(); return; }
    const marker = document.createComment('Category navigation original position');
    links.parentNode.insertBefore(marker, links);
    const slot = document.createElement('div');
    slot.className = 'vnk-category-toolbar';
    nav.insertBefore(slot, nav.querySelector('.popout--sort'));
    slot.appendChild(links);
    source.classList.add('vnk-category-section--integrated');
    nav.classList.add('vnk-collection-toolbar');
    current = { source, links, marker, slot, nav };
    // Recalculate the native sticky-header/sidebar offsets after the toolbar changes height.
    releasePending();
    window.dispatchEvent(new Event('resize'));
  }
  function schedule() {
    if (pending) return;
    pending = true; window.requestAnimationFrame(update);
  }
  desktop.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
  update();
})();
